import React from 'react';
import DeviceShell from '../components/DeviceShell';
import { Typography, Stack } from '@mui/material';

export default function AboutScreen() {
  return (
    <DeviceShell title="About">
      <Stack spacing={1}>
        <Typography color="text.primary" variant="h6">Smart Life India</Typography>
        <Typography color="text.secondary">One Stop Solution for the Smartest living possible.</Typography>
        <Typography color="text.secondary" variant="body2">
          React port of the SmartLifeIndia home-automation app. Control your Smartify devices in
          real time over MQTT. New-device Wi-Fi onboarding is handled in the mobile app.
        </Typography>
      </Stack>
    </DeviceShell>
  );
}
